import { useTelegram } from '../hooks/useTelegram'
import { Menu, Search, MoreVertical } from 'lucide-react'

export default function Header() {
  const { user, platform } = useTelegram()

  return (
    <header className="sticky top-0 z-50 bg-telegram-dark/95 backdrop-blur-md border-b border-telegram-secondary/10 safe-area-top">
      <div className="flex items-center justify-between h-14 px-4">
        {/* 左侧：菜单按钮 */}
        <button className="p-2 -ml-2 rounded-full hover:bg-telegram-secondary/20 transition-colors">
          <Menu className="w-6 h-6 text-telegram-text" />
        </button>

        {/* 中间：标题 */}
        <h1 className="text-lg font-semibold text-telegram-text">
          Telegram Mini App
        </h1>

        {/* 右侧：操作按钮 */}
        <div className="flex items-center space-x-1">
          <button className="p-2 rounded-full hover:bg-telegram-secondary/20 transition-colors">
            <Search className="w-5 h-5 text-telegram-text" />
          </button>
          <button className="p-2 rounded-full hover:bg-telegram-secondary/20 transition-colors">
            <MoreVertical className="w-5 h-5 text-telegram-text" />
          </button>
        </div>
      </div>

      {/* 用户信息条（可选） */}
      {user && (
        <div className="px-4 py-2 bg-telegram-blue/10 flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-telegram-blue rounded-full flex items-center justify-center">
              <span className="text-white text-sm font-medium">
                {user.first_name?.charAt(0) || 'U'}
              </span>
            </div>
            <span className="text-sm text-telegram-text">
              {user.first_name} {user.last_name}
            </span>
          </div>
          <span className="text-xs text-telegram-secondary">{platform}</span>
        </div>
      )}
    </header>
  )
}
